export default __webpack_public_path__ + "static/media/icon-back.ad412859.svg";